import { render, staticRenderFns } from "./DemandProfiles.vue?vue&type=template&id=01129e9c&"
import script from "./DemandProfiles.vue?vue&type=script&lang=js&"
export * from "./DemandProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports